export default __webpack_public_path__ + "static/media/Path3430.8bd0bd67.svg";